const Loading = () => {
  return <><div className="text-center"><span className="loader"></span></div></>;
};

export default Loading;
